import React from 'react';
import CountUp from '../common/CountUp';

const StatsSection = ({ animateStats }) => {
    return (
        <section id="stats-section" style={styles.statsSection}>
            <div style={styles.statsOverlay}></div>
            <div style={styles.container}>
                <div style={styles.statsGrid}>
                    <div style={styles.statCard}>
                        <div style={styles.iconContainer}>
                            <i className="fas fa-history" style={styles.statIcon}></i>
                        </div>
                        <div style={styles.statNumber}>
                            {animateStats ? 
                                <CountUp end={13} suffix="+" /> : 
                                <span>13+</span>
                            }
                        </div>
                        <div style={styles.statLabel}>Years of Excellence</div>
                    </div>
                    
                    <div style={styles.statCard}>
                        <div style={styles.iconContainer}>
                            <i className="fas fa-building" style={styles.statIcon}></i>
                        </div>
                        <div style={styles.statNumber}>
                            {animateStats ? 
                                <CountUp end={700} suffix="+" /> : 
                                <span>700+</span>
                            }
                        </div>
                        <div style={styles.statLabel}>Projects Delivered</div>
                    </div>
                    
                    <div style={styles.statCard}>
                        <div style={styles.iconContainer}>
                            <i className="fas fa-chart-line" style={styles.statIcon}></i>
                        </div>
                        <div style={styles.statNumber}>
                            {animateStats ? 
                                <CountUp end={40} suffix="%" /> : 
                                <span>40%</span>
                            }
                        </div>
                        <div style={styles.statLabel}>Annual Growth</div>
                    </div>
                </div>
            </div>
        </section>
    );
};

const styles = {
    statsSection: {
        padding: '80px 0',
        background: 'linear-gradient(135deg, #0f2b76 0%, #1e50d7 100%)',
        color: 'white',
        position: 'relative',
        overflow: 'hidden',
    },
    statsOverlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: 'url("/images/pattern-dot.png")',
        backgroundSize: '30px',
        opacity: 0.1,
        zIndex: 1,
    },
    container: {
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 20px',
        position: 'relative',
        zIndex: 2,
    },
    statsGrid: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        textAlign: 'center',
        gap: '30px',
    },
    statCard: {
        flex: '1 1 250px',
        maxWidth: '300px',
        padding: '40px 20px',
        borderRadius: '15px',
        background: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        boxShadow: '0 15px 30px rgba(0, 0, 0, 0.2)',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        '&:hover': {
            transform: 'translateY(-10px)',
            boxShadow: '0 20px 40px rgba(0, 0, 0, 0.3)',
        },
    },
    iconContainer: {
        width: '70px',
        height: '70px',
        margin: '0 auto 20px',
        borderRadius: '50%',
        background: 'linear-gradient(135deg, #4ade80 0%, #3b82f6 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 10px 20px rgba(59, 130, 246, 0.3)',
    },
    statIcon: {
        fontSize: '2rem',
        color: 'white',
    },
    statNumber: {
        fontSize: '3.5rem',
        fontWeight: '800',
        marginBottom: '10px',
        background: 'linear-gradient(90deg, #ffffff 0%, #e0e7ff 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        textShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    },
    statLabel: {
        fontSize: '1.3rem',
        fontWeight: '600',
        opacity: 0.9,
        letterSpacing: '0.5px',
    },
    '@media (max-width: 820px)': {
        statNumber: {
            fontSize: '3rem',
        },
        statCard: {
            padding: '30px 15px',
        },
        iconContainer: {
            width: '60px',
            height: '60px',
        },
        statIcon: {
            fontSize: '1.7rem',
        },
    },
    '@media (max-width: 576px)': {
        statsSection: {
            padding: '60px 0',
        },
        statCard: {
            flex: '1 1 100%',
            maxWidth: '100%',
            margin: '10px 0',
        },
    }
};

export default StatsSection;